import { Spinner } from "@salesapp/ui";
import type { DashboardKpiItem } from "../api";
import { Card } from "./UiCard";
import { useLocale } from "../../../../shell/LocaleProvider";

function formatKpi(
  value: number,
  item: DashboardKpiItem,
  formatMoney: (amount: number, currency?: string | null, compact?: boolean) => string,
  formatNumber: (amount: number, fractionDigits?: number) => string,
  currency: string,
): string {
  const column = item.column ?? "";
  const label = item.label ?? "";
  const money = /(^|\.)(value|total|amount|unit_price)$/i.test(column)
    || (item.aggregation === "sum" && /pipeline|invoiced|value|revenue|amount|won/i.test(label));
  if (money) return formatMoney(value, currency, true);
  if (item.aggregation === "avg") {
    const rounded = Math.round(value * 10) / 10;
    return formatNumber(rounded, Number.isInteger(rounded) ? 0 : 1);
  }
  return formatNumber(Math.round(value));
}

export function KpiCard({ item, value, loading }: { item: DashboardKpiItem; value: number | null; loading: boolean }) {
  const { formatMoney, formatNumber, orgCurrency } = useLocale();
  return (
    <Card className="dashboard-kpi-card">
      <div className="dashboard-kpi-card__label">{item.label}</div>
      {loading ? <Spinner /> : <div className="dashboard-kpi-card__value">{value == null ? "—" : formatKpi(value, item, formatMoney, formatNumber, orgCurrency)}</div>}
    </Card>
  );
}
